import { selectVirtualBackgroundStatus } from 'features/virtual-backgrounds/selectors';
import { AppThunk } from 'store/store';
import {
  virtualBackgroundActivationFailed,
  virtualBackgroundChanged,
  virtualBackgroundChangeStarted,
} from 'features/virtual-backgrounds/virtualBackgroundsSlice';
import { logger } from 'utils/logger';
import { SelectedVirtualBackground } from 'features/virtual-backgrounds/types';
import { VirtualBackgroundManager } from 'utils/webrtc/virtual-background/VirtualBackgroundManager';
import { getVirtualBackgroundFailureReason } from 'utils/webrtc/virtual-background/gateErrors';

interface ActivateVirtualBackgroundOptions {
  stream: MediaStream;
  selectedBackground: SelectedVirtualBackground;
}

export const activateVirtualBackground =
  (options: ActivateVirtualBackgroundOptions): AppThunk<Promise<MediaStream | void>> =>
  async (dispatch, getState) => {
    const status = selectVirtualBackgroundStatus(getState());
    if (status === 'updating') {
      return undefined;
    }
    dispatch(virtualBackgroundChangeStarted());

    try {
      const stream = await VirtualBackgroundManager.activateBackground({
        stream: options.stream,
        type: options.selectedBackground.type,
        value: options.selectedBackground.value,
      });

      logger
        .remote({ capture: 'virtual-background' })
        .log('The user applied virtual background', options.selectedBackground);

      dispatch(virtualBackgroundChanged(options.selectedBackground));

      return stream;
    } catch (error) {
      const reason = getVirtualBackgroundFailureReason(error);
      if (reason) {
        dispatch(
          virtualBackgroundActivationFailed({ reason, requested: options.selectedBackground })
        );
      }

      return undefined;
    }
  };
